export default __webpack_public_path__ + "static/media/instagram.4d3c7bf8.svg";